import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type DiscourseAuthTokensState = {
  sso?: string;
  sig?: string;
  clearDiscourseAuthTokens: () => void;
  setDiscourseAuthTokens: (sso: string, sig: string) => void;
};

export const useDiscourseAuthTokens = create<DiscourseAuthTokensState>()(
  persist(
    (set) => ({
      sso: undefined,
      sig: undefined,
      clearDiscourseAuthTokens: () => set({ sso: undefined, sig: undefined }),
      setDiscourseAuthTokens: (sso, sig) => set({ sso, sig }),
    }),
    {
      name: 'discourse-auth-tokens',
    }
  )
);
